import request from '@/utils/request'

const getList = (data) => {
  const { nameTH, page, limit, sort } = data
  let query = `page=${page + 1}&limit=${limit}&sortBy=${sort.field}&orderBy=${
    sort.type
  }`

  if (nameTH) query += `&nameTH=${encodeURI(nameTH)}`

  return request({
    url: `/api/categories/books?${query}`,
    method: 'get'
  })
}

const getListAll = () => {
  return request({
    url: `/api/categories/books?limit=10000&sortBy=name&orderBy=asc`,
    method: 'get'
  })
}

const create = (data) => {
  return request({
    url: `/api/categories/books`,
    method: 'post',
    data
  })
}

const update = (data) => {
  const { id } = data
  return request({
    url: `/api/categories/books/${id}`,
    method: 'patch',
    data
  })
}

const remove = (id) => {
  return request({
    url: `/api/categories/books/${id}`,
    method: 'delete'
  })
}

const download = () => {
  return request({
    url: `/api/categories/books/download`,
    method: 'get',
    responseType: 'blob'
  })
}

export default {
  getList,
  getListAll,
  create,
  update,
  remove,
  download
}
